import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';


export default function initSimpleSwiper(): void {
    const $simpleSwiperContainer = document.querySelectorAll<HTMLElement>('.js-simple-swiper');
    $simpleSwiperContainer.forEach($container => {
        new SimpleSwiper($container);
    });
}

/*
<div class="simple-swiper js-simple-swiper">
    <div class="container">
        <div class="swiper">
            <div class="swiper-wrapper">
                <div class="swiper-slide">
                    content slide
                </div>
            </div>
            <div class="simple-swiper-navigation only-desktop">
                <button type="button" class="button-prev"><?= __('précédent', 'limpide'); ?></button>
                <button type="button" class="button-next"><?= __('suivant', 'limpide'); ?></button>
            </div>
            <div class="simple-swiper-pagination only-mobile"></div>
        </div>
    <div>
</div>
*/

class SimpleSwiper {
    $el: HTMLElement | null | undefined;
    $slider: HTMLElement | null | undefined;
    $navigation_prev: HTMLElement | null | undefined;
    $navigation_next: HTMLElement | null | undefined;
    $pagination: HTMLElement | null | undefined;
    swiper: Swiper | null = null;


    constructor($el: HTMLElement | null) {
        this.$el = $el;
        this.$slider = $el?.querySelector('.swiper');
        this.$navigation_prev = $el?.querySelector('.button-prev');
        this.$navigation_next = $el?.querySelector('.button-next');
        this.$pagination = $el?.querySelector('.simple-swiper-pagination');
        this.init();
    }

    init(): void {
        if (this.$slider) {
            this.swiper = new Swiper(this.$slider, {
                modules: [Pagination, Navigation],
                slidesPerView: 'auto',
                loop: false,
                grabCursor: true,
                allowTouchMove: true,
                spaceBetween: 20,
                navigation: {
                    nextEl: this.$navigation_next,
                    prevEl: this.$navigation_prev,
                },
                pagination: {
                    el: this.$pagination,
                    clickable: true,
                }
            });
        }
    }
}
